import { transcribeAudio } from "../../../utils/transcriptionApi";

export interface VoiceHandlersConfig {
  startRecording: () => Promise<void>;
  stopRecording: () => Promise<Blob | null>;
  setIsTranscribing: (value: boolean) => void;
  setTranscriptionError: (error: string | null) => void;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}

export const createVoiceHandlers = (config: VoiceHandlersConfig) => {
  const handleStartVoiceRecording = async () => {
    try {
      config.setTranscriptionError(null);
      await config.startRecording();
    } catch (error) {
      console.error("Failed to start recording:", error);
      config.setTranscriptionError(
        error instanceof Error ? error.message : "Failed to start recording"
      );
    }
  };

  const handleStopVoiceRecording = async () => {
    try {
      config.setIsTranscribing(true);
      config.setTranscriptionError(null);

      const audioBlob = await config.stopRecording();

      if (!audioBlob) {
        throw new Error("No audio recorded");
      }

      // Transcribe the audio
      const transcribedText = await transcribeAudio(audioBlob);

      // Add transcribed text to input
      config.setInputValue((prev) => {
        const newValue = prev.trim();
        return newValue ? `${newValue} ${transcribedText}` : transcribedText;
      });
    } catch (error) {
      console.error("Transcription failed:", error);
      config.setTranscriptionError(
        error instanceof Error ? error.message : "Transcription failed"
      );
    } finally {
      config.setIsTranscribing(false);
    }
  };

  return {
    handleStartVoiceRecording,
    handleStopVoiceRecording,
  };
};

export interface ModalHandlersConfig {
  setIsConfirmModalOpen: (value: boolean) => void;
  setIsFieldConfigModalOpen: (value: boolean) => void;
}

export const createModalHandlers = (config: ModalHandlersConfig) => {
  return {
    openConfirmModal: () => config.setIsConfirmModalOpen(true),
    closeConfirmModal: () => config.setIsConfirmModalOpen(false),
    openFieldConfigModal: () => config.setIsFieldConfigModalOpen(true),
    closeFieldConfigModal: () => config.setIsFieldConfigModalOpen(false),
  };
};
